import * as z from 'zod';
import { ErrorMessages } from '../error-messages';

export const updateSchoolEmailFormSchema = z.object({
  email: z
    .string()
    .email(ErrorMessages.Email.INVALID)
    .refine(val => val.endsWith('.edu'), ErrorMessages.Email.MUST_BE_EDU),
});

export type UpdateSchoolEmailForm = z.TypeOf<
  typeof updateSchoolEmailFormSchema
>;
